module.exports = __webpack_public_path__ + "assets/1498b6d35fe80aa5b00b0d9398c0c27d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level4_Hit12s.mp3
 ** module id = 254
 ** module chunks = 0
 **/